<template>
  <v-container class="mt-12">
    <v-row dense>
      <v-col v-for="curso in cursos" :key="curso.id" cols="12" sm="6" md="4">
        <v-card class="rounded-xl elevation-8 hover-card">
          <!-- Imagen del curso -->
          <v-img
            :src="curso.imagen"
            height="180px"
            class="white--text d-flex align-end"
            gradient="to bottom, rgba(0,0,0,0.3), rgba(0,0,0,0.8)"
          >
            <v-card-title class="text-h6 font-weight-bold">
              {{ curso.nombre }}
            </v-card-title>
          </v-img>

          <!-- Contenido -->
          <v-card-text>
            <p class="grey--text text--darken-1">{{ curso.descripcion }}</p>

            <div class="mb-2">
              <strong>Modalidad:</strong>
              <span :class="{ 'text--disabled': !curso.disponible }">
                {{ curso.modalidad }}
              </span>
            </div>

            <div class="mb-2">
              <strong>Duración:</strong>
              <span :class="{ 'text--disabled': !curso.disponible }">
                {{ curso.duracion }}
              </span>
            </div>

            <!-- 💰 Precios -->
            <div class="mb-2">
              <strong>Precio:</strong>
              <span class="red--text font-weight-bold">S/ {{ curso.precio }}</span>
              <br />
              <small class="grey--text">
                Antes: <s>S/ {{ curso.precioAntes }}</s>
              </small>
            </div>

            <!-- Estado -->
            <v-chip
              :color="curso.disponible ? 'green' : 'red'"
              dark
              label
              small
              class="mt-2"
            >
              {{ curso.disponible ? "Disponible" : "No disponible" }}
            </v-chip>
          </v-card-text>

          <!-- Botones -->
          <v-card-actions>
            <v-btn
              color="primary"
              block
              class="rounded-lg"
              :disabled="!curso.disponible"
              @click="abrirFormulario(curso)"
            >
              Inscribirse
            </v-btn>
          </v-card-actions>

          <v-divider></v-divider>

          <!-- Botón de sílabo -->
          <v-card-actions>
            <v-btn
              color="secondary"
              block
              class="rounded-lg"
              :href="curso.silabo"
              target="_blank"
            >
              📄 Descargar Sílabo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Formulario de inscripción -->
    <v-dialog v-model="dialog" max-width="600px" persistent>
      <v-card class="rounded-xl">
        <v-card-title class="headline">
          Inscripción - {{ cursoSeleccionado?.nombre }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-img
                v-if="cursoSeleccionado?.imagen"
                :src="cursoSeleccionado.imagen"
                height="150px"
                contain
                class="rounded-lg"
              ></v-img>
            </v-col>
            <v-col cols="12" md="6">
              <p>
                <strong>Modalidad:</strong> {{ cursoSeleccionado?.modalidad }}<br />
                <strong>Duración:</strong> {{ cursoSeleccionado?.duracion }}<br />
                <strong>Precio:</strong>
                <span class="red--text font-weight-bold"
                  >S/ {{ cursoSeleccionado?.precio }}</span
                >
                <br />
                <small class="grey--text">
                  Antes: <s>S/ {{ cursoSeleccionado?.precioAntes }}</s>
                </small>
              </p>
            </v-col>
          </v-row>

          <v-form ref="form" v-model="valid">
            <v-text-field
              v-model="form.nombre"
              label="Nombre completo"
              :rules="nombreRules"
              required
              outlined
              dense
            ></v-text-field>

            <v-text-field
              v-model="form.email"
              label="Correo electrónico"
              :rules="emailRules"
              required
              outlined
              dense
            ></v-text-field>

            <v-text-field
              v-model="form.telefono"
              label="Teléfono"
              :rules="telefonoRules"
              outlined
              dense
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialog = false">Cancelar</v-btn>
          <v-btn
            color="success"
            class="rounded-lg"
            :disabled="!valid"
            @click="enviarFormulario"
          >
            Enviar inscripción
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Pop-out de confirmación -->
    <v-dialog v-model="confirmDialog" max-width="500px">
      <v-card class="rounded-xl pa-4 text-center">
        <v-card-title class="headline justify-center">
          ✅ ¡Inscripción exitosa!
        </v-card-title>
        <v-card-text>
          Gracias por inscribirte en <strong>{{ cursoSeleccionado?.nombre }}</strong
          >.
          <br />
          Nuestros asesores se estarán comunicando con usted lo más pronto posible.
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn color="primary" class="rounded-lg" @click="confirmDialog = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "ListaCursos",
  data() {
    return {
      dialog: false,
      valid: false,
      confirmDialog: false,
      cursoSeleccionado: null,
      form: {
        nombre: "",
        email: "",
        telefono: "",
      },
      // Validaciones
      nombreRules: [
        (v) => !!v || "El nombre es obligatorio",
        (v) => (v && v.length >= 3) || "El nombre debe tener al menos 3 caracteres",
      ],
      emailRules: [
        (v) => !!v || "El correo es obligatorio",
        (v) => /.+@.+\..+/.test(v) || "El correo debe ser válido",
      ],
      telefonoRules: [
        (v) =>
          !v || /^\d{7,15}$/.test(v) || "El teléfono debe tener entre 7 y 15 dígitos",
      ],
      cursos: [
        {
          id: 1,
          nombre: "Curso de Java",
          descripcion:
            "Aprende programación orientada a objetos y desarrollo backend con Java.",
          modalidad: "Virtual",
          duracion: "5 meses",
          disponible: true,
          precio: 380,
          precioAntes: 500,
          imagen: "https://cdn-icons-png.flaticon.com/512/226/226777.png",
          silabo: "/silabos/java.pdf",
        },
        {
          id: 2,
          nombre: "Curso de .NET",
          descripcion: "Desarrollo de aplicaciones web y servicios con .NET Core.",
          modalidad: "Semipresencial",
          duracion: "5 meses",
          disponible: false,
          precio: 380,
          precioAntes: 500,
          imagen: "https://cdn-icons-png.flaticon.com/512/6132/6132221.png",
          silabo: "/silabos/net.pdf",
        },
        {
          id: 3,
          nombre: "Curso de Python",
          descripcion:
            "Domina Python desde cero hasta proyectos prácticos de automatización y análisis de datos.",
          modalidad: "Presencial",
          duracion: "5 meses",
          disponible: true,
          precio: 400,
          precioAntes: 500,
          imagen: "https://cdn-icons-png.flaticon.com/512/5968/5968350.png",
          silabo: "/silabos/python.pdf",
        },
      ],
    };
  },
  methods: {
    abrirFormulario(curso) {
      this.cursoSeleccionado = curso;
      this.dialog = true;
    },
    enviarFormulario() {
      if (this.$refs.form.validate()) {
        console.log("Formulario enviado:", {
          curso: this.cursoSeleccionado,
          ...this.form,
        });
        this.dialog = false;
        this.form = { nombre: "", email: "", telefono: "" };
        this.confirmDialog = true;
      }
    },
  },
};
</script>

<style scoped>
.hover-card {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.hover-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2);
}
</style>
